module.exports = __webpack_public_path__ + "h5/img/404.6c69c022.png";